import React, { useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { AuthContext } from "../context/AuthContext";
import logo from "../assets/Logo.png";
import "./Navbar.css";
import TopNavbar from "./TopNavbar";

const Navbar = () => {
  const { isLoggedIn, userName } = useContext(AuthContext) || { isLoggedIn: false, userName: "" };
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  const NavItems = ({ onClick }) => (
    <>
      <li>
        <NavLink to="/" className="nav-link" onClick={onClick} end>
          Beranda
        </NavLink>
      </li>
      <li>
        <NavLink to="/berita-kakao" className="nav-link" onClick={onClick}>
          Berita Kakao
        </NavLink>
      </li>
      <li>
        <NavLink to="/kisah-sukses" className="nav-link" onClick={onClick}>
          Kisah Sukses
        </NavLink>
      </li>
            <li>
        <NavLink to="/ao" className="nav-link" onClick={onClick}>
          Nilai Kebun Saya
        </NavLink>
      </li>
      <li>
        <NavLink to="/agriservis" className="nav-link" onClick={onClick}>
          Penyedia Layanan Agri-Servis
        </NavLink>
      </li>
      <li>
        {/* selalu dapat diakses tanpa login */}
        <NavLink to="/pengembangandiri" className="nav-link" onClick={onClick}>
          Belajar Kakao Yuk!
        </NavLink>
      </li>
    </>
  );

  if (isLoggedIn) {
    return <TopNavbar userName={userName} />;
  }

  return (
    <>
      <header className="sb-navbar">
        <div className="sb-nav-inner">
          {/* Brand */}
          <Link to="/" className="sb-brand" aria-label="Sahabat Kakao">
            <img src={logo} alt="Sahabat Kakao" className="sb-logo" />
          </Link>

          {/* Menu desktop */}
          <nav className="sb-nav-desktop" aria-label="Menu utama">
            <ul className="sb-menu">
              <NavItems />
            </ul>
          </nav>

          {/* CTA kanan (desktop) */}
          <div className="sb-cta">
            <Link to="/login" className="sb-btn sb-btn-primary">
              Login
            </Link>
          </div>

          {/* Hamburger (mobile) */}
          <button
            className="sb-hamburger"
            aria-label={mobileOpen ? "Tutup menu" : "Buka menu"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((v) => !v)}
          >
            {mobileOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </header>

      {/* Backdrop */}
      <div
        className={`sb-backdrop ${mobileOpen ? "open" : ""}`}
        onClick={closeMobile}
      />

      {/* Drawer Mobile */}
      <aside
        className={`sb-drawer ${mobileOpen ? "open" : ""}`}
        aria-hidden={!mobileOpen}
      >
        <nav className="sb-drawer-nav" aria-label="Menu mobile">
          <ul className="sb-drawer-menu">
            <NavItems onClick={closeMobile} />
          </ul>

          <div className="sb-drawer-cta">
            <Link
              to="/login"
              className="sb-btn sb-btn-primary w-full"
              onClick={closeMobile}
            >
              Login
            </Link>
          </div>
        </nav>
      </aside>
    </>
  );
};

export default Navbar;
